<script setup lang="ts">
import { onMounted, ref, watch, h } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { routes } from '@/router/routes';
// 引入常用图标
import {
  HomeOutlined,
  LoginOutlined,
  DashboardOutlined,
  GiftOutlined,
  PictureOutlined,
  ScheduleOutlined,
  PlusCircleOutlined,
  FileSearchOutlined,
  CrownOutlined,
  TrophyOutlined,
  ThunderboltOutlined,
  UserOutlined,
  TeamOutlined,
  FileTextOutlined,
  AimOutlined,
  ShoppingCartOutlined,
  OrderedListOutlined,
  AppstoreOutlined,
  TagsOutlined,
  ShopOutlined,
  RocketOutlined,
  DeploymentUnitOutlined,
  ReadOutlined,
  CommentOutlined,
  FormOutlined,
  SettingOutlined,
  SafetyOutlined,
  ApartmentOutlined,
} from '@ant-design/icons-vue';
import { systemName } from '@/config';

const iconMap: Record<string, any> = {
  HomeOutlined,
  LoginOutlined,
  DashboardOutlined,
  GiftOutlined,
  PictureOutlined,
  ScheduleOutlined,
  PlusCircleOutlined,
  FileSearchOutlined,
  CrownOutlined,
  TrophyOutlined,
  ThunderboltOutlined,
  UserOutlined,
  TeamOutlined,
  FileTextOutlined,
  AimOutlined,
  ShoppingCartOutlined,
  OrderedListOutlined,
  AppstoreOutlined,
  TagsOutlined,
  ShopOutlined,
  RocketOutlined,
  DeploymentUnitOutlined,
  ReadOutlined,
  CommentOutlined,
  FormOutlined,
  SettingOutlined,
  SafetyOutlined,
  ApartmentOutlined,
};

const getIcon = (name?: string) => {
  return name && iconMap[name] ? iconMap[name] : AppstoreOutlined;
};

const router = useRouter();
const route = useRoute();

const props = defineProps({
  collapsed: Boolean,
});
const updateLogVisible = ref<boolean>(false);

const showRoutes = ref([]);

/**
 * 过滤路由
 * 不显示, 没权限的
 */
const filterRoutes = (routes: any[], grant: any[]): any[] => {
  const result: any[] = [];

  for (const route of routes) {
    // 不展示菜单，跳过
    if (route.meta?.renderMenu === false) continue;

    // 有权限控制，但没有权限，跳过
    if (route.grantKey && !grant.includes(route.grantKey)) continue;

    const newRoute = { ...route };

    // 如果有子路由，递归过滤
    if (newRoute.children && newRoute.children.length > 0) {
      newRoute.children = filterRoutes(newRoute.children, grant);
    }
    result.push(newRoute);
  }

  return result;
};

const grant = JSON.parse(localStorage.getItem('grant') || '[]');
showRoutes.value = filterRoutes(routes, grant);
const selectedKeys = ref<string[]>([]);

const findMenuIndex = (path: string) => {
  // 查找完全匹配的路由或子路由
  const route = showRoutes.value
    .flatMap((route) => [route, ...(route.children || [])])
    .find((route) => path === route.path || path.startsWith(route.path + '/'));
  return route ? route.path : 0;
};

watch(
  () => route.path,
  (newPath) => {
    const index = findMenuIndex(newPath);
    selectedKeys.value = [index];
  },
  { immediate: true },
);

onMounted(async () => {
  // 设置初始高亮
  const currentPath = route.path;
  const index = findMenuIndex(currentPath);
  selectedKeys.value = [index];

  const token = window.localStorage.getItem('token');
  if (token) {
    // 获取用户信息
  }

  updateLogVisible.value = true;
});
const menuClick = (menuItem, index) => {
  router.push({
    path: menuItem.path,
  });
};
const handleQuitLogin = async () => {
  router.push('/login');
  localStorage.removeItem('token');
  // userStore.clearUser()
};

const gotoPay = () => {
  // @ts-ignore
  window.payDialog.openDialog();
  // openDialog.value = true
};
const gotoIndex = () => {
  router.push('/index');
};
</script>

<template>
  <div class="relative h-full border-r border-[#f5f5f5]">
    <div
      class="flex items-center pl-[10px] gap-[10px] py-[10px] cursor-pointer mb-2"
      @click="gotoIndex"
    >
      <img
        src="@/assets/logo.png?url"
        class="w-[30px] h-[30px]"
      />
      <div
        v-if="!collapsed"
        class="text-[20px] font-bold"
      >
      {{systemName}}
      </div>
    </div>
    <a-menu
      v-model:selectedKeys="selectedKeys"
      mode="inline"
    >
      <a-sub-menu
        v-for="(item, index) in showRoutes"
        :key="item.path"
      >
        <template #title>
          <span class="inline-flex items-center">
            <component
              :is="getIcon(item.meta?.icon)"
              class="mr-2"
            />
            {{ item.name }}
          </span>
        </template>
        <a-menu-item
          v-for="(item1, index1) in item.children"
          @click="menuClick(item1, index1)"
          :key="item1.path"
        >
          <component
            :is="getIcon(item1.meta?.icon)"
            class="mr-2"
          />
          <span>{{ item1.name }}</span>
        </a-menu-item>
      </a-sub-menu>
    </a-menu>
  </div>
</template>

<style scoped lang="less"></style>
